module.exports = __webpack_public_path__ + "static/media/visoki_spiralni.d149d2b3.png";